<template>
  <div class="sign-up-form">
    <h2>Sign Up</h2>
    <DxForm ref="signUpForm" :formData="signUpData">
      <DxSimpleItem
        dataField="firstname"
        :editorOptions="{
          placeholder: 'John',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
      />
      <DxSimpleItem
        dataField="lastname"
        :editorOptions="{
          placeholder: 'Doe',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
      />
      <DxSimpleItem
        dataField="email"
        :editorOptions="{
          placeholder: 'john.doe@gmail.com',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
        :validationRules="[
          { type: 'required', message: 'Email is required' },
          { type: 'email', message: 'Email is invalid' },
          { 
            type: 'async', 
            validationCallback: (params) => {
              return this.checkEmailExists(params.value)
                .then(exists => {
                  console.log('Email exists:', exists); // Add logging here
                  return !exists; // Return true if email does not exist
                })
                .catch(error => {
                  console.error('Error during email validation:', error);
                  return false;
                });
            },
            message: 'Email already exists!'
          }
        ]"
      />
      <DxSimpleItem
        dataField="password"
        :editorOptions="{
          mode: 'password',
          placeholder: 'pass123',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
        :validationRules="[
          { type: 'required', message: 'Password is required' },
          { type: 'stringLength', min: 6, message: 'Password must be at least 6 characters long' },
          { 
            type: 'custom', 
            validationCallback: function(e) {
              const password = e.value;
              const hasUpperCase = /[A-Z]/.test(password);
              const hasLowerCase = /[a-z]/.test(password);
              const hasNumbers = /\d/.test(password);
              const hasSpecialChars = /[!@#$%^&*(),.?:{}|<>]/.test(password);
              return hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChars;
            },
            message: 'Password must contain upper and lower case letters, at least one number and one special character!'
          }
        ]"
      />
      <DxButtonItem
        :buttonOptions="{
          width: '100%',
          text: 'Sign Up',
          type: 'success',
          onClick: handleSignUp
        }"
        class="form-button"
      />
    </DxForm>
    <div class="sign-in-link">
      Already have an account? <a href="#" @click.prevent="showLoginForm">Sign In</a>
    </div>
  </div>
</template>

<script>
import { DxForm, DxSimpleItem, DxButtonItem } from 'devextreme-vue/form';
import { EventBus } from '../eventBus';

export default {
  components: {
    DxForm,
    DxSimpleItem,
    DxButtonItem
  },
  data() {
    return {
      signUpData: {
        firstname: '',
        lastname: '',
        email: '',
        password: ''
      }
    };
  },
  methods: {    
    async checkEmailExists(email) {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/check_email.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email })
        });
        const result = await response.json();
        console.log('API response exists:', result.exists); // Ensure this logs a boolean value
        return result.exists; // Ensure this returns true or false
      } catch (error) {
        console.error('Error during email validation:', error);
        return false; // Return false in case of an error
      }
    },
    async handleSignUp() {
  const formInstance = this.$refs.signUpForm?.instance;
  if (!formInstance) {
    console.error('Form instance is not available');
    return;
  }

  // Check if email exists first
  const emailExists = await this.checkEmailExists(this.signUpData.email);
  if (emailExists) {
    console.log('Email already exists, not proceeding with sign-up');
    return;
  }

  const result = await formInstance.validate();
  console.log('Validation result:', result);
  await result.complete; // Wait for all asynchronous validations to complete
  console.log('Validation complete:', result);
  if (result.isValid) {
    console.log('Form is valid, proceeding with sign-up');
    try {
      const response = await fetch(`${process.env.VUE_APP_API_URL}/create_user.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.signUpData)
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log(data);
      EventBus.emit('show-login-form', 'Success! You can now login!');
    } catch (error) {
      console.error('Error signing up:', error);
    }
  } else {
    console.log('Form is invalid, not proceeding with sign-up');
  }
},
    showLoginForm() {
      EventBus.emit('show-login-form');
    }
  }
};
</script>

<style scoped>
.sign-up-form {
  max-width: 400px;
  margin: 0 auto;
  border-radius: 4px;
}

.sign-up-form h2 {
  color: var(--base-text-color);
  text-align: center;
  line-height: 24px;
  font-weight: 500;
  font-size: 24px;
}

.form-button {
  width: 100%;
  margin-top: 10px;
}

.sign-in-link {
  margin-top: 20px;
  text-align: center;
}

.sign-in-link a {
  color: #007bff;
  text-decoration: none;
}

.sign-in-link a:hover {
  text-decoration: underline;
}
</style>